import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    ICoOpRegionBudget,
    UpdateCoOpRegionBudgets
    } from '..';
import { uiActionCreators } from '../../ui';

function* updateCoOpRegionBudgetsSaga(action: UpdateCoOpRegionBudgets) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: ICoOpRegionBudget[] = yield call(api.updateCoOpRegionBudgets, action.payload);

  yield put(coOpActionCreators.setRegionBudgets(response));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpRegionBudgets() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_REGION_BUDGETS, updateCoOpRegionBudgetsSaga);
}
